import axios from 'axios'

export default class RayonService {
  public getAll() {
    return axios.get('/api/v1/rayons/')
  }
}
